'use strict';

const {flag, name, code} = require('./lib.js');

module.exports = {flag, name, code};



//////////////////
// WEBPACK FOOTER
// ./node_modules/country-emoji/main.js
// module id = FtmS
// module chunks = 0